/** @format */

// export const ProjectsArray = [
//   {
//     // skill: "React",
//     // name: "Chat app",
//     // desp: "Real time chat application using nodejs and socket.io.",
//     // img: "https://i.ibb.co/YyRP2F0/screencapture-chatroomapp1-herokuapp-2022-05-24-11-34-49-1.webp",
//     // hoverImg:
//     //   "https://i.ibb.co/TDQrgQ9/screencapture-chatroomapp1-herokuapp-user-room-2022-05-24-11-45-28-1.png",
//     // href: "https://web-production-b3d5e.up.railway.app/",
//     // org: false,
//     // keyword: ["Node", "All"],
//   },
//   {
//     // skill: "React",
//     // name: "Ecommerce store",
//     // desp: "Here you can buy and upload products.Integrated CI/CD pipeline with backend deployed to docker and heroku.",
//     // img: "https://i.ibb.co/KrJRBZ1/q2-1-1.webp",
//     // hoverImg:
//     //   "https://i.ibb.co/HHpWHHG/screencapture-shoestorea-netlify-app-categ-options-2022-05-25-11-49-14-1.webp",
//     // href: "https://shoestorea.netlify.app/",
//     // org: false,
//     // keyword: ["React", "Node", "Mongodb", "All"],
//   },

//   // {
//   //   skill: "React",
//   //   name: "Ecommerce website",
//   //   desp: "Ecommerce website created using Commercejs with payment gateway of stripe",
//   //   img: "https://i.ibb.co/1s6KWcr/s-1.webp",
//   //   hoverImg:
//   //     "https://i.ibb.co/TY0qs8t/screencapture-shoeecommerceweb-netlify-app-items-cart-2022-05-24-12-18-51-1.webp",
//   //   keyword: ["React", "Mern", "All"],
//   // },
//   {
//     // skill: "React",
//     // name: "Super bloger",
//     // desp: "Blog website where user can upload photos & videos",
//     // img: "https://i.ibb.co/NxNL8xD/Screenshot-7.png",
//     // hoverImg: "https://i.ibb.co/M5cdcfr/Screenshot-8.png",
//     // org: false,
//     // href: "https://superbloger.netlify.app/",
//     // keyword: ["React", "Nest", "Postgres", "All"],
//   },
//   {
//     // skill: "React",
//     // name: "Blog posts",
//     // desp: "Create and manage Blogs with private mode enabled.MERN stack app",
//     // img: "https://i.ibb.co/R3sMqdp/m6-1.webp",
//     // hoverImg:
//     //   "https://i.ibb.co/pnxp7np/screencapture-reactblogwebsite-netlify-app-post-2022-05-24-12-08-05-1.webp",
//     // href: "https://reactblogwebsite.netlify.app/",
//     // org: false,
//     // keyword: ["React", "Mern", "Node", "Mongodb", "All"],
//   },
//   {
//     skill: "Node",
//     name: "Pyura face mask",
//     desp: "Buy face mask ecommerce website",
//     img: "https://i.ibb.co/vXk2c9K/a-1-1.webp",
//     org: true,
//     hoverImg: "https://i.ibb.co/XpdLRFY/a1-1.webp",
//     href: "https://pyura.netlify.app/",
//     keyword: ["Mern", "React", "Node", "Mongodb", "All"],
//   },
//   {
//     skill: "Mern",
//     name: "Survey website",
//     desp: "Here you can upload the videos of the terrain.Here the videos are uploaded to AWS S3 bucket.",
//     img: "https://i.ibb.co/kMSjPn1/lyso-1.webp",
//     hoverImg: "https://i.ibb.co/nLzWWBy/l2-1.webp",
//     org: true,
//     href: "https://lyso.netlify.app/",
//     keyword: ["Mern", "React", "Node", "All", "Mongodb"],
//   },
//   //   {
//   //     skill: "Mern",
//   //     name: "Images website",
//   //     desp: "Search,download and upload images for free",
//   //     img: "https://i.ibb.co/zXwF3CR/i-1.webp",
//   //     hoverImg: "https://i.ibb.co/5vML57q/i2-1.webp",
//   //     href: "https://imagesapp.netlify.app/",
//   //     org: false,
//   //     keyword: ["React", "Mern", "All"],
//   //   },
//   {
//     skill: "React",
//     name: "Movies App",
//     desp: "Here I use moviedb API to fetch all the latest movies and popular movies.",
//     img: "https://i.ibb.co/WHh0V7J/m4-1.webp",
//     hoverImg: "https://i.ibb.co/NFKDs1r/m3-1.webp",
//     href: "https://movieslistapps.netlify.app/",
//     org: false,
//     keyword: ["React", "All"],
//   },
// ];

export const ProjectsArray = [
  {
    skill: "Node",
    name: "Movies and Tv Shows",
    desp: "Full stack website, were user can follow others also rate and save favourite tv shows and movies",
    img: "https://i.ibb.co/j5PX0Xk/Screenshot-1.png",
    org: false,
    hoverImg: "https://i.ibb.co/pbJ06QB/Screenshot-2.png",
    href: "https://movies-karthikq2.vercel.app/",
    keyword: ["Mern", "React", "Node", "Mongodb", "All"],
  },
  {
    skill: "Node",
    name: "Pyura face mask",
    desp: "Buy face mask ecommerce website",
    img: "https://i.ibb.co/vXk2c9K/a-1-1.webp",
    org: true,
    hoverImg: "https://i.ibb.co/XpdLRFY/a1-1.webp",
    href: "https://pyura.netlify.app/",
    keyword: ["Mern", "React", "Node", "Mongodb", "All"],
  },
  {
    skill: "Mern",
    name: "Survey website",
    desp: "Here you can upload the videos of the terrain.Here the videos are uploaded to AWS S3 bucket.",
    img: "https://i.ibb.co/kMSjPn1/lyso-1.webp",
    hoverImg: "https://i.ibb.co/nLzWWBy/l2-1.webp",
    org: true,
    href: "https://lyso.netlify.app/",
    keyword: ["Mern", "React", "Node", "All", "Mongodb"],
  },
];
